import { Box } from '@chakra-ui/react';

const Layout = ({ children, padding }) => <Box padding={padding}>{children}</Box>;

export default Layout;
